import { schemes } from "@zeal/common";
import { z } from "zod";

export const getFinixInfoRequestSchema = z.object({
  companyID: schemes.uuid(),
});

export type TGetFinixInfoRequestSchema = z.infer<
  typeof getFinixInfoRequestSchema
>;

export const getFinixInfoResponseSchema = z.object({
  business_profile_id: z.string().optional(),
  finixSandboxApiUrl: z.string(),
  finixApplication: z.string(),
  env: z.string(),
});

export type TGetFinixInfoResponseSchema = z.infer<
  typeof getFinixInfoResponseSchema
>;
